import React, { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useIdleTimer } from 'react-idle-timer';

import Box from '@mui/material/Box';
import { styled } from '@mui/system';

// COMPONENTES IMPORTADOS
import { NavigationBar } from '../components/ui/NavigationBar';
import { HomeScreen } from '../screens/home/HomeScreen';
import { Quicksight } from '../screens/pruebas/QuicksightScreen';
import { FlowsScreen } from '../screens/flows/FlowsScreen';
import { Users } from '../screens/users/UsersScreen';
import { SignatureDigital } from '../screens/digitalSignature/DigitalSignatureScreen';
import { OpprtunityScreen } from '../screens/crmOpportunity/OpprtunityScreen';
import { LayoutApproval } from '../screens/approval/layout/LayoutApproval';
import { CompaniesScreen } from '../screens/companies/CompaniesScreen';
import { InterfaceScreen } from '../screens/interface/InterfaceScreen';
import { ServicesScreen } from '../screens/services/ServicesScreen';
import { ProviderScreen } from '../screens/provider/ProviderScreen';
import { ContactScreen } from '../screens/contact/ContactScreen';
import { MeetingsScreen } from '../screens/crm/MeetingsScreen';
import { ClientScreen } from '../screens/client/ClientScreen';
import { GroupScreen } from '../screens/group/GroupScreen';
import { InvoiceScreen } from '../screens/invoice/InvoiceScreen';
import { InvoiceExportScreen } from '../screens/invoiceExport/InvoiceExportScreen';
import { DebitNoteScreen } from '../screens/debitNote/DebitNoteScreen';
import { CreditNoteScreen } from '../screens/creditNote/CreditNoteScreen';
import { WhatsAppScreen } from '../screens/whatsApp/WhatsAppScreen';
import { StoreScreen } from '../screens/store/StoreScreen';
import { OrderScreen } from '../screens/order/OrderScreen';
import { SmartFormEngineScreen } from '../screens/smartFormEngine/SmartFormEngineScreen';
import { ActionSelectionScreen } from '../screens/actionSelection/ActionSelectionScreen';
import  SupportDocumentScreen  from '../screens/supportDocument/SupportDocumentScreen';
import ChatWidget from '../components/chatagent/ChatWidget';
//ACA LOS NUEVOS IMPORTS
// COMPONENTES IMPORTADOS

// CORRESPONDEN A RUTAS ACCESIBLES SIN AUTH Y CON AUTH
// POR ESTA RAZON SE ESTA IMPORTANDO DIRECTAMENTE EL Layout, YA QUE NO ESTAMOS VALIDANDO VISTAS EN EL PRIVATE ROUTER
import { LayoutSharedViews } from '../screens/sharedViews/layout/LayoutSharedViews';
import { LayoutCharts } from '../screens/charts/layout/LayoutCharts';

import ErrorBoundaryWrapper from '../components/ErrorHandling/ErrorBoundaryWrapper';
import { useDataAuth } from '../hooks/useDataAuth';

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
}));

const Main = styled(props => (
    <Box {...props} />
))(({ theme }) => ({
    backgroundColor: theme.palette.light.main,
}));

const initialStyles = {
    flexGrow: 1,
    pr: 2,
    pl: 2,
    pb: 7,
    boxShadow: ' 10px 10px 5px -18px rgba(0,0,0,0.75)',
    height: 'calc(100%)',
    overflow: 'auto',
}

export const MainRouter = () => {
    const [{ handleLogout }] = useDataAuth();
    const timeout = 1000 * 60 * 20;//Cantidad milisegundos
    const [chatOpen, setChatOpen] = useState(false);
    const [customStyles, setCustomStyles] = useState(initialStyles);
    const [showDrawer, setShowDrawer] = useState(false);

    // Do some idle action like log out your user
    const onIdle = () => handleLogout();
    const onActive = (event) => { console.log("onActive ", event) }
    useIdleTimer({ timeout, onIdle, onActive });

    const changeCustomStyles = (styles) => {
        setCustomStyles({
            ...customStyles,
            ...styles
        })
    }

    const routes = [
        { path: '/Quicksight/*', element: <Quicksight /> },
        { path: '/flows/*', element: <FlowsScreen /> },
        { path: '/tableViews/:params/*', element: <LayoutSharedViews /> },
        { path: '/users/*', element: <Users /> },
        { path: '/opportunity/*', element: <OpprtunityScreen /> },
        { path: '/companies/*', element: <CompaniesScreen /> },
        { path: '/interface/*', element: <InterfaceScreen /> },
        { path: '/provider/*', element: <ProviderScreen /> },
        { path: '/signatureDigital/*', element: <SignatureDigital /> },
        { path: '/charts/*', element: <LayoutCharts /> },
        { path: '/approval/*', element: <LayoutApproval /> },
        { path: '/group/*', element: <GroupScreen /> },
        { path: '/services/*', element: <ServicesScreen /> },
        { path: '/client/*', element: <ClientScreen /> },
        { path: '/crmvisitas/*', element: <MeetingsScreen /> },
        { path: '/contact/*', element: <ContactScreen /> },
        { path: '/store/*', element: <StoreScreen /> },
        { path: '/order/*', element: <OrderScreen /> },
        { path: '/whatsApp/*', element: <WhatsAppScreen changeCustomStyles={changeCustomStyles} initialStyles={initialStyles} setShowDrawer={setShowDrawer} /> },
        { path: '/invoice/*', element: <InvoiceScreen /> },
        { path: '/invoiceExport/*', element: <InvoiceExportScreen /> },
        { path: '/debitNote/*', element: <DebitNoteScreen /> },
        { path: '/creditNote/*', element: <CreditNoteScreen /> },
        { path: '/supportDocument/*', element: <SupportDocumentScreen /> },
        { path: '/smartForm/*', element: <SmartFormEngineScreen /> },
        { path: '/actionSelection/*', element: <ActionSelectionScreen /> }
    ];

    const toggleChat = () => setChatOpen((prev) => !prev);

    return (
        <Box sx={{ display: 'flex', height: '100%', overflow: 'hidden' }}>
            <NavigationBar onChatToggle={toggleChat} />

            {/* Floating Chat Agent Widget */}
            <ChatWidget isOpen={chatOpen} onClose={() => setChatOpen(false)} />

            <Main
                component="main"
                sx={customStyles}
            >
                {!showDrawer && <DrawerHeader />}
                <Routes>
                    <Route path="/home/*" element={<HomeScreen />} />
                    <Route path="*" element={<Navigate to="/home" />} />

                    {routes.map(({ path, element }) => (
                        <Route
                            key={path}
                            path={path}
                            element={
                                <ErrorBoundaryWrapper>
                                    {element}
                                </ErrorBoundaryWrapper>
                            }
                        />
                    ))}
                </Routes>
            </Main>
        </Box>
    )
}
